import { PropsWrapper } from './PropsWrapper';
import classNames from 'classnames';

import styles from './Wrapper.module.scss';

export const Wrapper = ({ children, className }: PropsWrapper): JSX.Element => {
  return (
    <div className={classNames(styles.Wrapper, className)}>
      <div className={styles.Container}>
        <div className={styles.Arrow}></div>
        {children}
      </div>
    </div>
  );
};
